import { createSimpleFunctional } from '../../util/helpers'
import App from './App.vue'

const AppBar = createSimpleFunctional('app__bar')

export default {
  App,
  AppBar
}



// WEBPACK FOOTER //
// ./src/components/app/index.js